import React from 'react';
import { Hero } from './components/Hero';
import { AboutBook } from './components/AboutBook';
import { WhatYoullLearn } from './components/WhatYoullLearn';
import { AboutAuthor } from './components/AboutAuthor';
import { Testimonials } from './components/Testimonials';
import { EbookPurchase } from './components/EbookPurchase';
import { FormsSection } from './components/Forms';
import { FAQ } from './components/FAQ';
import { FinalMessage } from './components/FinalMessage';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-cream overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <AboutBook data-id="element-2" />
      <WhatYoullLearn data-id="element-3" />
      <AboutAuthor data-id="element-4" />
      <Testimonials data-id="element-5" />
      <EbookPurchase data-id="element-6" />
      <FormsSection data-id="element-7" />
      <FAQ data-id="element-8" />
      <FinalMessage data-id="element-9" />
      <Footer data-id="element-10" />
    </main>;
}